const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')

const automatedMessage = yup.object().shape({
  title: yup.string(),
  body: yup.string(),
  triggerMessageOn: yup.string().oneOf(['enter', 'exit']).default('enter'),
  delayMinutes: yup.number().default(0),
  frequency: yup.string().oneOf(['once', 'onceDaily', 'everytime']).default('once'),
})

const shape = labelify({
  name: yup.string().ensure(''),
  description: yup.string().ensure(''),
  feature: yup
    .object()
    .shape({
      id: yup.string(),
      type: yup.string(),
      properties: yup.mixed(),
      geometry: yup.mixed().label('Region geometry').required(),
    })
    .optional(),
  radius: yup.number().min(0).label('Region radius').default(1),
  persistenceDurationMinutes: yup.number().min(0).label('Persistence duration (minutes)').default(60),
  active: yup.boolean().default(true),
  automatedMessages: yup.array().of(automatedMessage).default([]),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const geofenceRegionSchemaPartial = yup.object().shape(shape)
const geofenceRegionSchema = geofenceRegionSchemaPartial.shape(requiredFields(['name'])(shape))

module.exports = { geofenceRegionSchema, geofenceRegionSchemaPartial, automatedMessage }
